import { render, staticRenderFns } from "./AssessmentAccess.vue?vue&type=template&id=7c8636f4"
import script from "./AssessmentAccess.vue?vue&type=script&lang=js"
export * from "./AssessmentAccess.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports